import type { AdminKpisPieSectionTableActionsProps } from "../../models/admin-kpis.models";
import { ADMIN_KPIS_TABLE_ACTION_BUTTON_CLASS_NAME } from "../../utils/admin-kpis.utils";
import { memo } from "react";

const AdminKpisPieSectionTableActions = ({ onShowAll, onHideTable }: AdminKpisPieSectionTableActionsProps) => {
  return (
    <span className="flex flex-none items-center gap-3">
      <button type="button" className={ADMIN_KPIS_TABLE_ACTION_BUTTON_CLASS_NAME} onClick={onShowAll}>
        Show all
      </button>
      <button type="button" className={ADMIN_KPIS_TABLE_ACTION_BUTTON_CLASS_NAME} onClick={onHideTable}>
        Hide table
      </button>
    </span>
  );
};

export default memo(AdminKpisPieSectionTableActions);
